import { Control } from './control';

import ClientFullscreen from './client-fullscreen/ClientFullscreen.vue';
import Fullscreen from './fullscreen/Fullscreen.vue';
import NativeFullscreen from './native-fullscreen/NativeFullscreen.vue';
import Interprefy from './interprefy/Interprefy.vue';
import Help from './help/Help.vue';
import Language from './language/Language.vue';
import Resolution from './resolution/Resolution.vue';
import LiveBadge from './live-badge/LiveBadge.vue';
import PlayPauseToggle from './play-pause-toggle/PlayPauseToggle.vue';
import PlayStopToggle from './play-stop-toggle/PlayStopToggle.vue';
import PreviewBadge from './preview-badge/PreviewBadge.vue';
import SidebarToggle from './sidebar-toggle/SidebarToggle.vue';
import Time from './time/Time.vue';
import Volume from './volume/Volume.vue';
import Viewers from './viewers-count/ViewersCount.vue';

export enum PredefinedControl {
    // Emits event to client that will handle fullscreen, the whole VideoPlayer component will be fullscreened
    // Side bar CAN be used
    ClientFullscreen = 'client-fullscreen',
    // Adds a smvp-fullscreen class to the VideoPlayerCore component, only the VideoPlayerCore component will be fullscreened with position: fixed
    // Side bar CANNOT be used
    Fullscreen = 'fullscreen',
    // Uses the native fullscreen API, only the VideoPlayerCore component will be fullscreened
    // Side bar CANNOT be used
    NativeFullscreen = 'native-fullscreen',
    Interprefy = 'interprefy',
    Help = 'help',
    Language = 'language',
    LiveBadge = 'live-badge',
    PlayPauseToggle = 'play-pause-toggle',
    PlayStopToggle = 'play-stop-toggle',
    PreviewBadge = 'preview-badge',
    Resolution = 'resolution',
    SidebarToggle = 'sidebar-toggle',
    Time = 'time',
    Viewers = 'viewers-count',
    Volume = 'volume'
}

export default {
    get [PredefinedControl.ClientFullscreen](): Control {
        return {
            id: PredefinedControl.ClientFullscreen,
            component: ClientFullscreen,
            rightAlign: true
        };
    },

    get [PredefinedControl.Fullscreen](): Control {
        return {
            id: PredefinedControl.Fullscreen,
            component: Fullscreen,
            rightAlign: true
        };
    },

    get [PredefinedControl.NativeFullscreen](): Control {
        return {
            id: PredefinedControl.NativeFullscreen,
            component: NativeFullscreen,
            rightAlign: true
        };
    },

    get [PredefinedControl.Interprefy](): Control {
        return {
            id: PredefinedControl.Interprefy,
            component: Interprefy,
            rightAlign: true
        };
    },

    get [PredefinedControl.Help](): Control {
        return {
            id: PredefinedControl.Help,
            component: Help,
            rightAlign: true
        };
    },

    get [PredefinedControl.Language](): Control {
        return {
            id: PredefinedControl.Language,
            component: Language,
            rightAlign: true
        };
    },

    get [PredefinedControl.Resolution](): Control {
        return {
            id: PredefinedControl.Resolution,
            component: Resolution,
            rightAlign: true
        };
    },

    get [PredefinedControl.LiveBadge](): Control {
        return {
            id: PredefinedControl.LiveBadge,
            component: LiveBadge
        };
    },

    get [PredefinedControl.PlayPauseToggle](): Control {
        return {
            id: PredefinedControl.PlayPauseToggle,
            component: PlayPauseToggle
        };
    },

    get [PredefinedControl.PlayStopToggle](): Control {
        return {
            id: PredefinedControl.PlayStopToggle,
            component: PlayStopToggle
        };
    },

    get [PredefinedControl.PreviewBadge](): Control {
        return {
            id: PredefinedControl.PreviewBadge,
            component: PreviewBadge
        };
    },

    get [PredefinedControl.SidebarToggle](): Control {
        return {
            id: PredefinedControl.SidebarToggle,
            component: SidebarToggle,
            rightAlign: true
        };
    },

    get [PredefinedControl.Time](): Control {
        return {
            id: PredefinedControl.Time,
            component: Time
        };
    },

    get [PredefinedControl.Viewers](): Control {
        return {
            id: PredefinedControl.Viewers,
            component: Viewers
        };
    },

    get [PredefinedControl.Volume](): Control {
        return {
            id: PredefinedControl.Volume,
            component: Volume
        };
    }
} as Record<string, Control>;
